import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'
import { useAdmin } from '../../../contexts/AdminContext'
import Card from '../../../components/Card'
import cx from 'classnames'
import styles from './SubscriptionOverview.module.css'
import CurrentSubscription from '../../../compositions/Subscription/CurrentSubscription'
import { showToast } from '../../../services/ToastService'
import Heading from '../../../components/Heading'
import { useNavigate } from 'react-router-dom'
import Loader from '../../../components/Loader'

const SubscriptionOverview: React.FC = () => {
    const { getSubscription, subscription, user, loggingIn } = useAdmin()
    const { t } = useTranslation(['settings'])
    const navigate = useNavigate()

    useEffect(() => {
        if (user) {
            navigate('/subscription/admin')
        }
    }, [user, navigate])

    return !loggingIn ? (
        <>
            <Heading level={2} classes={'zr-mt-4'}>
                {t('subscription.subscription')}
            </Heading>
            <div className={cx(styles['container'], 'zr-my-6')}>
                {subscription && (
                    <Card
                        title={t('subscription.currentSubscription')}
                        actions={[
                            {
                                title: t('subscription.syncWithServer'),
                                type: 'secondary',
                                onAction: () => {
                                    getSubscription()
                                    showToast(t('subscription.syncSuccess'))
                                },
                                classes: 'zr-m-3 zr-w-100',
                            },
                        ]}
                    >
                        <CurrentSubscription />
                    </Card>
                )}
                <Card
                    title={t('subscription.alreadyACustomer')}
                    actions={[
                        {
                            title: t('subscription.login'),
                            type: 'primary',
                            onAction: () => navigate('/subscription/login'),
                            classes: 'zr-m-3 zr-w-100',
                        },
                    ]}
                >
                    <div className={'zr-pb-3'}>
                        <p>{t('subscription.alreadyACustomerText')}</p>
                    </div>
                </Card>
                <Card
                    title={t('subscription.newCustomer')}
                    actions={[
                        {
                            title: t('subscription.registerNow'),
                            type: 'primary',
                            onAction: () => navigate('/subscription/register'),
                            classes: 'zr-m-3 zr-w-100',
                        },
                    ]}
                >
                    <div className={'zr-pb-3'}>
                        {t('subscription.newCustomerText')}
                    </div>
                </Card>
            </div>
        </>
    ) : (
        <div className={'zr-w-100 zr-d-flex zr-justify-center'}>
            <Loader isLoading={loggingIn} size={'l'} />
        </div>
    )
}

export default SubscriptionOverview
